import { styled, Box, Typography } from '@mui/material';

export const FormWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '0px',
  width: '100%',
  height: '100%',
}));

export const ButtonWrapper = styled(Box)(() => ({
  marginTop: '16px',
  display: 'flex',
  width: '100%',
}));

export const ErrorText = styled(Typography)(() => ({
  margin: '0px 0px 12px 12px',
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontWeight: '400',
  fontSize: '11px',
  lineHeight: '1.43',
  letterSpacing: '0.01071em',
  color: 'rgb(209, 67, 67)',
}));

export const LoaderWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 239,
  '&>div': {
    backgroundColor: '#fafafa00',
  },
}));
